export default "__VITE_ASSET__DWZnlmzq__"